import React,{useContext} from 'react'
// import { Link,useNavigate } from 'react-router-dom';
import Link from 'next/link';

import lplogo from '../images/lightningcategory/lightning_protection_logo.svg';
import thorimg from '../images/lightningcategory/thor_image.png';
import thorimg2x from '../images/lightningcategory/thor_image@2x.png';

import zeus from '../images/lightningcategory/zeus_image.png';
import zeus2x from '../images/lightningcategory/zeus_image@2x.png';

import air from '../images/lightningcategory/air_terminal_image.png';
import air2x from '../images/lightningcategory/air_terminal_image@2x.png';

import frank from '../images/lightningcategory/franklyn.png';
import frank2x from '../images/lightningcategory/franklyn@2x.png';

import ltacc from '../images/lightningcategory/lightning_accessories.png';
import ltacc2x from '../images/lightningcategory/lightning_accessories@2x.png';

import spd from '../images/lightningcategory/spd.png';
import spd2x from '../images/lightningcategory/spd@2x.png';

import wkit from '../images/lightningcategory/welding_kit.png';
import wkit2x from '../images/lightningcategory/welding_kit2x.png';


// import Thordetailscontent from './Thordetailscontent';
import { ProductContext } from './Productcontext';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling animation
    });
  };
    const LightningCategoryContent = () => {
        // let navigate = useNavigate();
        const router = useRouter();
        const { selectedProduct, setProduct ,setCategory } = useContext(ProductContext);
        const roundedbottom={
          borderBottomLeft:10,
          borderBottomRight:10

        }
        const handleProductSelect = (product) => {
            setProduct(product);
            setCategory('slpr');
            //console.log("clieck product using context="+product);
            // navigate('/lps');
            if(product=='thor')
                router.push('/ashlok-thor-safe-protection-lightning-rod');
            else if(product=='zeus')
                router.push('/ashlok-zeus-slpr');
            else if(product=='frank')
                router.push('/ashlok-franklyn-penta');
            else if(product=='air')
                router.push('/ashlok-air-terminal');
            else if(product=='spd')
                router.push('/ashlok-surge-protection-device');
            else if(product=='exo_kit')
                router.push('/ashlok-exothermic-welding-kit');
            else if(product =='access')
                router.push('/ashlok-alice-digital');
            else if(product =='earth_test_link')
                router.push('/ashlok-earthing-test-link');
            else if(product =='equi_busbar')
                router.push('/ashlok-equipotential-busbar');
            else if(product =='slpr_mast')
                router.push('/ashlok-slpr-mast');
            else if(product =='slpr_acc')
                router.push('/ashlok-slpr-accessories-kit');
           else
                router.push('/ashlok-thor-safe-protection-lightning-rod');

            scrollToTop();
                /*
            if(product==="thor")
                navigate('/thordetails');
            else if(product==="zeus")
                navigate('/zeusdetails');
            else if(product==="air")
                navigate('/airterminaldetails');
            else if(product==="frank")
                navigate('/franklynpentadetails');
            else if(product==="access")
                navigate('/lightaccdetails');
            else if(product==="spd")
                navigate('/spddetails');
            
             <Route path="/lps/:ipage" element={<Lightningprotectionsystems/>}/>
          <Route path="/thordetails" element={<Thordetailscontent/>}/>
          <Route path="/zeusdetails" element={<Zeusdetailscontent/>}/>
          <Route path="/airterminaldetails" element={<Airterminaldetailscontent/>}/>
          <Route path="/franklynpentadetails" element={<Franklynpentacontent/>}/>
          <Route path="/exotermicdetails" element={<Exotermicweldingkitdetails/>}/>
          <Route path="/spddetails" element={<Spddetailscontent/>}/>
          <Route path="/lightaccdetails" element={<Lightningaccessoriesdetails/>}/>

            */

            
        }

      return (
        <div className=' w-full flex-col mx-auto flex justify-center items-center m-5 px-2 lg:px-0'>
            <Image src={lplogo} alt="Lightning Protection Ashlok Safe Earthing Electrode Limited"/>
            <h1 class="hidden">Lightning Protection Systems — Design, Supply &amp; Installation</h1>
            <div className='container w-max-xl flex flex-col md-small:flex-row md:flex-row lg:flex-row justify-center items-center md:m-5 mt-5 md:mt-10 lg:m-5 lg:mt-10 lg:space-x-16 px-2 lg:px-0' >
                <div className='flex flex-col w-full md-small:mx-2 md:mx-2 lg:w-1/5  my-2 lg:my-0 bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}} onClick={() =>handleProductSelect('thor')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={thorimg2x} alt="Thor SLPR Lightning Arrestors for Building Protection - Ashlok Safe Earthing Electrode Limited"
                        />
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm" >
                        <p className="text-l font-bold text-center"><span className='vollkorn-sc-semibold'>Thor® SLPR</span></p>
                       
              
                        {/* <p className="text-base line-clamp-3">Ashlok’s range of lps safeguards the solar farms from the harmful impact of lightning.</p>
                         
                        
                            <div className='flex justify-end items-end' >
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                        
                    </div>
                </div>
                <div className='flex flex-col w-full lg:w-1/5 md-small:mx-2 md:mx-2 my-2 lg:my-0 bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('zeus')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={zeus2x} alt="ZEUS SLPR Lightning Arrestors for Building Protection - Ashlok Safe Earthing Electrode Limitedg"/>
                       {/* srcSet={`${zeus} 1x, ${zeus2x} 2x`}/> */}
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold text-center"><span className='vollkorn-sc-semibold'>Zeus® SLPR</span></p>
                        {/* <p className="text-base line-clamp-3">Safeguarding the telecom towers from lightning ashlok’s lps provides the ultimate safety.</p>
                         
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                          
                    </div>
                </div>

                <div className='flex flex-col w-full lg:w-1/5  md-small:mx-2 md:mx-2 my-2 lg:my-0    bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('frank')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={frank2x} alt="Franklyn Multi-point Lightning Air Terminal System - Ashlok Safe Earthing Electrode Limited"/>
                        {/*  srcSet={`${frank} 1x, ${frank2x} 2x`}/> */}
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>Franklyn Penta</span></p>
                        {/* <p className="text-base line-clamp-3">Lps of ashlok enables the lightning to be dissipated whilst providing protection to the structure.</p>
                       
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                            
                    </div>
                </div>
                

            </div>
            {/* second row */}
            <div className='container w-max-xl flex flex-col md-small:flex-row  md:flex-row lg:flex-row justify-center md:m-5 md:mt-10 lg:m-5 lg:mt-10 lg:space-x-16 px-2 lg:px-0'>
                
                <div className='flex flex-col w-full  lg:w-1/5 md-small:mx-2 md:mx-2 my-2 lg:my-0 bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('air')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={air2x} alt="Copper and Aluminum Earthing Air Terminal with Flat Base - Ashlok Safe Earthing Electrode Limited"/>
                        {/*  srcSet={`${air} 1x, ${air2x} 2x`}/> */}
                    </div>
                    <div className="p-4  text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold text-center"><span className='vollkorn-sc-semibold'>Air Terminal</span></p>
                        {/*<p className="text-base line-clamp-3">Giving a high range of protection against lightning, our products has benchmarked in oil & gas sector.</p>
                         <p className=' text-ashblack'>Franklyn Penta  </p>
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                           
                    </div>
                </div>

                <div className='flex flex-col w-full lg:w-1/5 md-small:mx-2 md:mx-2 my-2 lg:my-0 bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('spd')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={spd2x} alt="Surge Protection Device (SPD) - Ashlok Safe Earthing Electrode Limited" />
                        {/*  srcSet={`${spd} 1x, ${spd2x} 2x`}/> */}
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>SPD</span></p>
                        {/* <p className="text-base line-clamp-3 ">Is your electrical and electronic equipment shielded from lightning and transient surges?</p>
                        <p className="text-base text-ashblack">Ashlok safe earthing</p>
                           
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                           
                    </div>
                </div>
                <div className='flex flex-col w-full lg:w-1/5  md-small:mx-2 md:mx-2  my-2 bg-ashgray1 rounded-lg cursor-pointer justify-end' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('exo_kit')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={wkit2x} alt="Welding Kit for Earthing Systems Installation - Ashlok Safe Earthing Electrode Limited" />
                       {/*   srcSet={`${wkit} 1x, ${wkit2x} 2x`}/> */}
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>Exothermic Welding KIT                     </span></p>
                        {/* <p className="text-base line-clamp-4"> <span className='vollkorn-sc-semibold'>Ashlok's</span> ExoThermic Welding Kit offers superior thermal performance and safety.</p>
                        <p className="text-base text-ashblack">Ashlok safe earthing</p>
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                           
                    </div>
                </div>
                

            </div>
            {/* Third Row */}
               
            <div className='container w-max-xl flex  flex-col md-small:flex-row md:flex-row lg:flex-row  justify-center md:m-5 md:mt-10 lg:m-5 lg:mt-10 lg:space-x-16 px-2 lg:px-0'>
                <div className='flex flex-col w-full lg:w-1/5 md-small:mx-2 md:mx-2  my-2 bg-ashgray1 rounded-lg cursor-pointer justify-end ' style={{border:'black 1px solid',borderRadius:4}}  onClick={() =>handleProductSelect('access')}>
                    <div className=' flex justify-center items-center'>
                        <Image src={ltacc2x} alt="Ashlok A.L.I.C.E Digital Lightning Impulse Counter - Ashlok Safe Earthing Electrode Limited" />
                        {/*  srcSet={`${ltacc} 1x, ${ltacc2x} 2x`}/> */}
                    </div>
                    <div className="p-4 text-center sm:text-left bg-ashblack text-white rounded-sm">
                        <p className="text-l font-bold line-clamp-1 text-center"><span className='vollkorn-sc-semibold'>Accessories</span></p>
                        {/* <p className="text-base line-clamp-4">Our range of air terminals are positioned around the edge of the roof and on high points providing the ultimate protection.</p>
                          
                            <div className='flex justify-end items-end'>
                                <div className='p-2   h-6  bg-ashred text-xs text-white flex items-center justify-center rounded-sm'>Explore
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                            </div> */}
                           
                    </div>
                </div>
                <div className='flex flex-col  w-full lg:w-1/5 md-small:mx-2 md:mx-2  my-2   rounded-lg cursor-pointer justify-end'>
                </div>
                <div className='flex flex-col w-full lg:w-1/5 md-small:mx-2 md:mx-2  my-2 rounded-lg cursor-pointer justify-end'>
                </div>

            </div>

                {/* hide content */}
                <div>
                    <p className="sr-only">spd</p>
                    <p className="sr-only">exothermic welding</p>
                    <p className="sr-only">whole house surge protector</p>
                    <p className="sr-only">ac surge protector</p>
                    <p className="sr-only">spd surge protection device</p>
                </div>

        </div>
      )
    }
    
    export default LightningCategoryContent
    